import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcListH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 18a1 1 0 0 1 1-1h40a1 1 0 1 1 0 2H23a1 1 0 0 1-1-1M9 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M22 36a1 1 0 0 1 1-1h40a1 1 0 1 1 0 2H23a1 1 0 0 1-1-1M9 36a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M22 54a1 1 0 0 1 1-1h40a1 1 0 1 1 0 2H23a1 1 0 0 1-1-1M9 54a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }));
}
var IcListH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcListH72));

export { IcListH72 as I };
